import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";

export type ErrorMessageProps = {
	message: string;
};

export const ErrorMessage = (props: ErrorMessageProps): ReactElement => {
	const {
		message
	} = props;

	return (
		<p {...setTrackingId("error-message")}>{message}</p>
	);
};
ErrorMessage.displayName="ErrorMessage";